import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
//#region src/inline-alert/inline-alert.tsx
var i = r("group/inline-alert flex w-full flex-col items-stretch gap-2 rounded-lg border border-dashed p-4 has-data-[slot=inline-alert-title]:has-data-[slot=inline-alert-description]:items-start tablet:flex-row tablet:items-center tablet:gap-3", {
	variants: { variant: {
		neutral: "bg-bg-tertiary border-border-300",
		positive: "bg-bg-success-light border-border-success-light",
		warning: "bg-bg-warning-light border-border-warning-light",
		danger: "bg-bg-error-light border-border-error-light"
	} },
	defaultVariants: { variant: "neutral" }
}), a = t(({ children: t, className: r, variant: a, role: o, ...s }, c) => /* @__PURE__ */ n("div", {
	ref: c,
	className: e(i({ variant: a }), r),
	"data-slot": "inline-alert",
	"data-testid": "inline-alert",
	"data-variant": a,
	role: o ?? (a === "danger" ? "alert" : "status"),
	...s,
	children: t
}));
a.displayName = "InlineAlert.Root";
var o = t(({ className: t, ...r }, i) => /* @__PURE__ */ n("span", {
	ref: i,
	"data-slot": "inline-alert-icon",
	"data-testid": "inline-alert-icon",
	className: e("bg-bg-primary flex size-8 shrink-0 items-center justify-center self-start rounded-lg [&>svg]:size-4", "group-data-[variant=neutral]/inline-alert:text-icon-primary", "group-data-[variant=positive]/inline-alert:text-icon-success", "group-data-[variant=warning]/inline-alert:text-icon-warning", "group-data-[variant=danger]/inline-alert:text-icon-error", t),
	...r
}));
o.displayName = "InlineAlert.Icon";
var s = t(({ className: t, ...r }, i) => /* @__PURE__ */ n("div", {
	ref: i,
	"data-slot": "inline-alert-content",
	"data-testid": "inline-alert-content",
	className: e("flex min-w-0 flex-1 flex-col gap-1", t),
	...r
}));
s.displayName = "InlineAlert.Content";
var c = t(({ className: t, ...r }, i) => /* @__PURE__ */ n("span", {
	ref: i,
	"data-slot": "inline-alert-title",
	"data-testid": "inline-alert-title",
	className: e("truncate text-base font-medium", t),
	...r
}));
c.displayName = "InlineAlert.Title";
var l = t(({ className: t, ...r }, i) => /* @__PURE__ */ n("span", {
	ref: i,
	"data-slot": "inline-alert-description",
	"data-testid": "inline-alert-description",
	className: e("text-text-tertiary text-sm", t),
	...r
}));
l.displayName = "InlineAlert.Description";
var u = t(({ className: t, ...r }, i) => /* @__PURE__ */ n("div", {
	ref: i,
	"data-slot": "inline-alert-actions",
	"data-testid": "inline-alert-actions",
	className: e("tablet:ml-auto tablet:w-auto tablet:shrink-0 tablet:justify-start tablet:self-center flex w-full items-center justify-center gap-2", t),
	...r
}));
u.displayName = "InlineAlert.Actions";
var d = Object.assign(a, {
	Icon: o,
	Content: s,
	Title: c,
	Description: l,
	Actions: u,
	Root: a
});
//#endregion
export { d as InlineAlert };
